import React from "react";

import Lottie from "lottie-react";
import groovyWalkAnimation from "../../assets/lottie/loading.json";

export const Loading = () => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <Lottie animationData={groovyWalkAnimation} />
    </div>
  );
};
